import React, { Component } from "react";
import { Card, Carousel } from "react-bootstrap";
import { HashRouter } from "react-router-dom";
import Portraet from "./pictures/Domi.jpg";
import Cloud from "./pictures/about.svg";

class About extends Component {
  onClickAppointment = () => this.props.history.push("/appointment");
  render() {
    return (
      <HashRouter>
        <Card>
          <Card.Body>
            <Card.Title className="big mainColor bold mb-2  ">
              {/*Dominique Ramona Treder-Osigus*/}
            </Card.Title>
            <Card.Subtitle className="mb-5">
              {/*<span style={{ fontStyle: "italic" }}>Friseurmeisterin</span>
              <br></br>
              <br></br>*/}
              <div className="cardTextPadding">
                Mit{" "}
                <span className="big mainColor bold">großer Leidenschaft</span>{" "}
                gehe ich meiner Tätigkeit als{" "}
                <span className="big mainColor bold">Friseurmeisterin</span>{" "}
                nach, um den{" "}
                <span className="big mainColor bold">hohen Ansprüchen</span>{" "}
                meiner Kundinnen und Kunden an eine gelungene Frisur gerecht zu
                werden. <br></br>
                <br></br>
                <span className="big mainColor bold">Ich berate</span> Sie
                gerne, und{" "}
                <span className="big mainColor bold">verhelfe Ihnen</span> zu
                der <span className="big mainColor bold">Frisur</span> die
                perfekt zu Ihrem Typ passt.
              </div>
            </Card.Subtitle>
            <Card.Img src={Portraet}></Card.Img>
            {/*<Card.Text className="cardTextPaddingTop"></Card.Text>
            <img style={{ width: "120%" }} src={Cloud} />*/}
          </Card.Body>
        </Card>
        {/* <Carousel indicators={false} controls={false} interval={5000}>
          <Carousel.Item>
            <div className="cardTextPadding">
              Mit{" "}
              <span className="big mainColor bold">großer Leidenschaft</span>{" "}
              gehe ich meiner Tätigkeit als{" "}
              <span className="big mainColor bold">Ihre Friseurmeisterin</span>{" "}
              nach, um den{" "}
              <span className="big mainColor bold">hohen Ansprüchen</span>{" "}
              meiner Kundinnen und Kunden an eine gelungene Frisur gerecht zu
              werden. <span className="big mainColor bold">Ich berate</span> Sie
              gerne, und{" "}
              <span className="big mainColor bold">verhelfe Ihnen</span> zu der{" "}
              <span className="big mainColor bold">Frisur</span> die perfekt zu
              Ihrem Typen passt.
            </div>
          </Carousel.Item>
           <Carousel.Item>
             <img style={{ width: "100%" }} src={Cloud} /> 
          </Carousel.Item> 
        </Carousel> */}
      </HashRouter>
    );
  }
}
export default About;
